import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

import * as layouts from './layouts'

@ngCore.Component({
  imports: [
    layouts.basic.Component,
    layouts.scrolling.Component,
    layouts.tabbed.Component,
    ds.illustration.emptyState.Component,
    ds.loader.Component,
  ],
  selector: 'atn-mosaic-page-content',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.endUser.currentRendering.Feature } */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )
}
